// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b291bfd7","513":"77125400","703":"3f94d0f2","787":"3c3dd2e3"}[chunkId] + ".chunk.js";
};